//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'PaginationCatalog',
  props: {
    pagination: {
      type: Object
    }
  },
  data: function data() {
    return {
      history: []
    };
  },
  created: function created() {
    console.log(this.pagination);
  },
  methods: {
    goFirst: function goFirst() {
      this.pagination.current = 1;
      this.emitChange();
    },
    goNext: function goNext() {
      console.log("go next");
      this.pagination.current++;
      this.emitChange();
    },
    goPrev: function goPrev() {
      this.pagination.current--;
      this.emitChange();
    },
    emitChange: function emitChange() {
      console.log("emit change");
      this.$emit('changePagina', this.pagination.current);
    },
    goInput: function goInput() {
      console.log("go input");
      this.$emit('changePagina', this.pagination.current);
    },
    getTotalPage: function getTotalPage() {
      return Math.ceil(this.pagination.total / this.pagination.limit);
    }
  }
};